import components from './componentsDictionary';

const AvailableComponentLists = (componentName, props, children, blocks, canvasWidth, wrapper, componentId) => {
	const list = [...components];

	const getComp = list.find((e) => e.componentName === componentName);

	if (!getComp) {
		console.error(`Componente ${componentName} nâo encontrado. Verifique o objeto AvailableComponentLists`);
		return null;
	}
	const Comp = getComp.componentData;

	//wrapper para casos onde é necessária a adição de estrututura adicional sem afetar o JSON
	//Wrappers não recebem props exatamente por esse motivo
	if (wrapper) {
		console.log('NAME: ', wrapper);

		const getWrapper = list.find((e) => e.componentName === wrapper);
		const Wrapper = getWrapper.componentData;
		return (
			<Wrapper>
				<Comp {...props} {...{ children, blocks, canvasWidth, componentId }} />
			</Wrapper>
		);
	}
	return <Comp {...props} {...{ children, blocks, canvasWidth, componentId }} />;
};

export default AvailableComponentLists;
